import React from "react";
import { TokenProvider } from ".";

export const TokenProviderContext = React.createContext<TokenProvider>(() =>
  Promise.reject(),
);
